import { render, staticRenderFns } from "./ModelSpec.vue?vue&type=template&id=425c9384"
import script from "./ModelSpec.vue?vue&type=script&lang=js"
export * from "./ModelSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports